import { render } from "./EmployeeLeaveBalance.vue?vue&type=template&id=587da9fd&scoped=true"
import script from "./EmployeeLeaveBalance.vue?vue&type=script&lang=js"
export * from "./EmployeeLeaveBalance.vue?vue&type=script&lang=js"

import "./EmployeeLeaveBalance.vue?vue&type=style&index=0&id=587da9fd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-587da9fd"]])

export default __exports__